// extracted by mini-css-extract-plugin
module.exports = {"verifiedOld":"verified-badge_verifiedOld__HXrp3","verifiedBlue":"verified-badge_verifiedBlue__ZtlMy","verifiedGovernment":"verified-badge_verifiedGovernment__l1k4z"};